export const MAX_TITLE_LENGTH = 100;
export const MAX_UNIT_LENGTH = 10;